// Third Party Libraries Imports
import toast from "react-hot-toast";
import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";

// Local Imports
import { LOADING } from "../../store/actions";
import instance from "../../store/axios";

class WithdrawalService {
  private dispatch = useDispatch();

  public async getWithdrawalListData(
    status: string[],
    page,
    searchWord,
    sortField,
    sortOrder
  ): Promise<any[] | undefined> {
    this.dispatch({ type: LOADING, payload: true });
    let query: string = `?page=${page}&pageSize=20`;

    status.forEach((element: string, index: number) => {
      if (index === 0) {
        query += `&status[${index}]=${element}`;
      } else {
        query += `&status[${index}]=${element}`;
      }
    });

    if (searchWord) {
      query += `&search=${searchWord}`;
    }

    if (sortField) {
      query += `&sortField=${sortField}`;
    }
    if (sortOrder) {
      query += `&sortOrder=${sortOrder === "ascend" ? "asc" : "desc"}`;
    }

    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/withdraw${query}`
      );
      return response.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/withdrawal`);
      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }

  public async getWithdrawDetailsData(
    withdrawalId: string | undefined
  ): Promise<any[] | undefined> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<{
        data: any[];
        message: string;
      }> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/withdraw/${withdrawalId}`
      );
      return response.data.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/withdrawal`);
      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }

  public async takeAction(
    withdrawId: string | undefined,
    action: string,
    statusReason: string,
    notes: string,
    transactionId: string
  ): Promise<string | undefined> {
    this.dispatch({ type: LOADING, payload: true });

    this.dispatch({ type: LOADING, payload: true });
    try {
      await instance.post(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/withdraw/${withdrawId}/review`,
        {
          approved: action === "approve" ? true : false,
          statusReason,
          notes,
          transactionId,
        }
      );
      action === "approve"
        ? toast.success("Withdraw approved successfully")
        : toast.success("Withdraw rejected successfully");
      return "success";
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/withdrawal`);
    }
    this.dispatch({ type: LOADING, payload: false });
  }
}

export default WithdrawalService;
